const normalize = (value: string) => value.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')

// While typing: lowercase, replace disallowed chars with '-', collapse repeats; do NOT trim.
export const sanitizeSlugInput = (value: string) => normalize(value).replace(/[^a-z0-9-]+/g, '-').replace(/-{2,}/g, '-')

// Final form: also trims leading/trailing hyphens.
export const slugify = (value: string) => sanitizeSlugInput(value).replace(/^-+|-+$/g, '')

// Public booking pages live on the booking.* subdomain of the current host.
export const bookingHost = () => window.location.host.replace(/^app\./, 'booking.')
